// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__4PrW6","list":"style_list__2vzLG","goods_name":"style_goods_name__Ng5W1"};